// export const base_path = "/react/template";
export const base_path ='/'

// if (process.env.NODE_ENV === 'production') {
    // path = '/react/template/';
// } else {
//     // Use a different path for local development
//     path = '/';
// }
// export const image_path = '/react/template/'  // for Production
export const image_path = '/'                // for Development